import { Typography } from "@mui/material";
import { persianDigitWithSeprator } from "./components/PersianDigit";
function TotalChart({ total, size }) {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  return (
    <>
      {total?.map((item) => {
        return (
          <Typography
            fontSize={size ? size : 14}
            sx={{
              width: { md: "15%", xs: "40%" },
              padding: { md: "0", xs: "0.5rem 0" },
            }}
            key={item?.key || "default-key"}
            margin={{ md: "0 1rem", xs: "0 0.5rem" }}
            color={item?.color || "inherit"}
            textAlign={"start"}
          >
            {persianDigitWithSeprator(item.title)}{" "}
            {persianDigitWithSeprator(item.count)
              ? ":" + persianDigitWithSeprator(item.count)
              : ""}
          </Typography>
        );
      })}
    </>
  );
}

export default TotalChart;
